import React, { FC } from 'react';
import { Box, Divider, useTheme } from '@material-ui/core';
import CashFinanceGroup from '../cashFinanceGroup/CashFinanceGroup';
import PriceSectionContainer from '../PriceSection/PriceSectionContainer';
import Grid from '@material-ui/core/Grid';
import useIsMobile from '../../../../../common/react/useIsMobile';
import financeProductGridElementStyles from './financeProductGridElementStyles';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import clsx from 'clsx';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import InsuranceBlockFinanceContainer from '../../customiseControls/insuranceBlock/InsuranceBlockFinanceContainer';
import { useHistory } from 'react-router-dom';
import * as queryString from 'query-string';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';
export interface IFinanceProductGridElementProps {
  setIsFinCalcSpcModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isFinCalcSpcModalOpen: boolean;
  isCash: boolean;
  isMultiCurrency: boolean;
  isCtaDisabled: boolean;
}

const FinanceProductGridElement: FC<IFinanceProductGridElementProps> = ({
  setIsFinCalcSpcModalOpen,
  isFinCalcSpcModalOpen,
  isCash,
  isMultiCurrency,
  isCtaDisabled,
}) => {
  const style = financeProductGridElementStyles();
  const history = useHistory();
  const params = queryString.parse(history.location.search);
  const { loading, selectedCar } = useCustomizeCarContext();
  const {
    platformConfig: { isFinanceEnabled },
  } = usePlatformConfig();
  const {
    spc: {
      customise: { availableFinanceElements, footer },
    },
  } = useTheme<ISpcTheme>();
  const isMobile = useIsMobile();

  return (
    <Grid item={true} lg={8} sm={12} className={style.gridElement}>
      <Box
        className={clsx(style.container, {
          [style.columnLayout]: isMobile && (isMultiCurrency || footer?.largeAmountStyle),
          [style.cacheContainer]: isCash,
        })}
      >
        {isFinanceEnabled && (
          <CashFinanceGroup
            setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
            isCash={isCash}
            isMultiCurrency={isMultiCurrency}
            isCtaDisabled={isCtaDisabled}
          />
        )}
        <Box className={style.priceDisplayElement}>
          {isMobile &&
            !isCash &&
            !isMultiCurrency &&
            !footer?.largeAmountStyle &&
            availableFinanceElements?.length <= 3 && (
              <Divider
                orientation="vertical"
                className={style.mobileDivider}
                data-test={'finance_values:mobile_divider'}
              />
            )}
          {!!selectedCar && (
            <PriceSectionContainer
              selectedCar={selectedCar}
              setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
              isFinCalcSpcModalOpen={isFinCalcSpcModalOpen}
              loading={loading}
            />
          )}
          <Divider orientation="vertical" className={style.divider} />
          {params.carCode && <InsuranceBlockFinanceContainer displayBlock={!!selectedCar?.insurance?.displayBlock} />}
        </Box>
      </Box>
    </Grid>
  );
};

export default FinanceProductGridElement;
